<template>
	<nav class="bottom-nav">
		<ul>
			<li>
				<router-link to="/" tag="a">
					<ion-icon name="paper"></ion-icon>
					<p>Home</p>
				</router-link>
			</li>
			<li>
				<a @click.prevent="showNotifications">
					<ion-icon name="ios-notifications"></ion-icon>
					<p>Notifications</p>
					<span
						v-if="notificationCount > 0"
						class="stackng-notification"
						:title="`You have ${notificationCount} Notifications`"
					></span>
				</a>
			</li>
			<li v-if="$store.state.user.user.username">
				<router-link :to="{path: `/s/${$store.state.user.user.username}`}" tag="a">
					<ion-icon name="logo-buffer"></ion-icon>
					<p>Stack</p>
				</router-link>
			</li>
			<li v-if="$store.state.user.user.username">
				<a @click.prevent="showGroups">
					<ion-icon name="ios-contacts"></ion-icon>
					<p>Groups</p>
				</a>
			</li>
		</ul>
	</nav>
</template>

<script>
import { groupsMixin } from "../mixins/groupsMixin";
import { notificationsMixin } from "../mixins/notificationsMixin";

export default {
	mixins: [groupsMixin, notificationsMixin],
	computed: {
		notificationCount() {
			return this.$store.getters.getNotifications.length;
		}
	},
	methods: {
		showNotifications() {
			this.showNotificationsModal();
		},
		showGroups() {
			this.showGroupsModal();
		}
	}
};
</script>

<style scoped>
nav {
	display: none;
	position: fixed;
	/* width: 100%; */
	transition: all 0.3s ease;
	z-index: 10;
	height: 50px;
	-webkit-overflow-scrolling: auto;
	background-color: #000;
	bottom: 0;
	width: 100%;
	transition: 0.3s ease all;
	box-shadow: rgba(15, 15, 15, 0.05) 0px 0px 0px 1px,
		rgba(15, 15, 15, 0.1) 0px 5px 10px, rgba(15, 15, 15, 0.2) 0px 15px 40px;
}

ul {
	display: flex;
	width: 100%;
	align-items: center;
}

li {
	flex: 1;
}

li a {
	display: block;
	text-align: center;
	color: #b7b7b7;
	text-decoration: none;
	height: 100%;
	position: relative;
	cursor: pointer;
}

ion-icon {
	font-size: 27px;
	color: #51c715;
}

p {
	font-size: 10px;
	margin-top: -8px;
}

.stackng-notification {
	left: 35px;
	top: 0px;
}

@media only screen and (max-width: 540px) {
	nav {
		display: flex;
		/* align-items: center;
            justify-content: space-around; */
	}
}
</style>


// WEBPACK FOOTER //
// src/components/BottomNav.vue